import styled from '@emotion/styled';
import {Button} from '@mui/material';

interface Props {
  fontSize?: any;
}
export const CustomTextButton = styled(Button)<Props>`
  font-family: ${props => props.theme.typography.fontFamily};
  text-transform: capitalize;
  font-size: ${(p: any) => p.fontSize || '16px'};
  box-shadow: none;
  /* color:  */
  display: flex;
  justify-content: center;
  align-items: center;
`;
